import axios from 'axios'
const aiportMixin = {
  data () {
    return {
      origin: '',
      destination: '',
      multicity: true,
      dates: null
    }
  },
  watch: {
    disabledDatepicker: function () {
      if (this.disabledDatepicker) {
        this.dates = null
        this.dateRange = null
      } else {
        this.getDatesAvailable()
      }
    },
  },
  beforeMount () {
    this.getAirports()
    // this.handleSearchBeforeSelected()
  },
  methods: {
    getAirports() {
      var displayTarget = this.displayTarget || this.$store.getters.getDisplayTarget
      var keysToShow = Object.keys(displayTarget).filter(e => displayTarget[e] === true)
      this.airports =  Object.values(this.bookingData.enabledRoutes.information)
      .map(e => ({
        airport: e,
        name: this.getAirportNameToShowV2(e, displayTarget, keysToShow)
      }))
      this.airports.sort((a, b) => {
        return a.airport.city.description < b.airport.city.description ? -1 : (a.airport.city.description > b.airport.city.description ? 1 : 0)
      })
    },
    getAirportNameToShowV2: function (x, displayTarget, keysToShow) {
      let res = []
      let description = []

      if (this.bookingData.searchParameters.findIndex(p => p.airport_code === x.code) >= 0) {
        x.description = `airport_name_${x.code}`
      }

      if (displayTarget.airport_name) description.push(`${this.$t(x.description).toUpperCase()}`)
      if (displayTarget.city_code) description.push(`${x.city.code}`)
      if (displayTarget.city_name) description.push(`${x.city.description}`)
      if (displayTarget.country_code) description.push(`(${x.city.country.code})`)
      if (displayTarget.country_name) description.push(`${x.city.country.description}`)
      if (displayTarget.airport_code) res.push(`${x.code} ${keysToShow.length > 1 ? '- ' : ''}`)
      res.push(description.join(description.length > 1 ? ', ' : ' '))
      return res.join('')
    },
    getDatesAvailable: function () {
      this.$nextTick(() => {
        const datePickerEl = document.querySelector('.--has-fancy')
        const progress = document.createElement('div')
        const indeterminate = document.createElement('div')
        progress.classList.add('fancyProgress')
        indeterminate.classList.add('indeterminate')
        progress.appendChild(indeterminate)
        datePickerEl.appendChild(progress)
        var url = this.getApiUrl()
        axios.defaults.headers.common['Carrier'] = this.$store.getters.getCarrier
        axios({
          method: 'get',
          url: `${url}/dates/`,
          params: {
            origin: this.origin,
            destination: this.destination,
            is_round_trip: this.roundTrip ? 1 : 0
          }
        })
          .then((response) => {
            this.dates = response.data.response
          })
          .catch((e) => {
            console.log('error api get dates', e)
          })
          .finally(() => {
            document.querySelector('.--has-fancy .fancyProgress').remove()
          })
      })
    },
    getApiUrl (searchForm=false) {
      let apiBookingVersion = 'v1'
      if (searchForm) {
        apiBookingVersion = get(this.$store.getters, 'getApiVersion', 'v1')
      }
      let path = 'searchflight/api/' + apiBookingVersion
      return (this.customUrls? this.customUrls.base + path : this.$store.getters.getConfigUrls.apiBaseUrl + path )
    },
  },
  computed: {
    getOriginAirports () {
      let results = []
      if (this.destination && this.bookingData.enabledRoutes.return[this.destination]) {
        results = this.bookingData.enabledRoutes.return[this.destination]
          .map(route => this.airports
          .find(({airport}) => airport.code === route))
      }
      else {
        const airportKey = Object.keys(this.bookingData.enabledRoutes.outgoin)
        results = this.airports.filter(value =>  airportKey.includes(value.airport.code) )
      }
      return results.sort((a, b) => {
        return a.airport.city.description < b.airport.city.description ? -1 : (a.airport.city.description > b.airport.city.description ? 1 : 0)
      })
    },
    getDestinationAirports () {
      let results = []
      if (this.origin && this.bookingData.enabledRoutes.outgoin[this.origin]) {
        results = this.bookingData.enabledRoutes.outgoin[this.origin]
          .map(route => this.airports
          .find(({airport}) => airport.code === route))
      }
      else {
        const airportKey = Object.keys(this.bookingData.enabledRoutes.return)
        results = this.airports.filter(value =>  airportKey.includes(value.airport.code) )
      }

      return results.sort((a, b) => {
        return a.airport.city.description < b.airport.city.description ? -1 : (a.airport.city.description > b.airport.city.description ? 1 : 0)
      })
    },
    disabledDatepicker: function () {
      return (!(this.origin && this.destination))
    },
  }
}

export default aiportMixin